import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyAZTTZii_8sPcYMcn-YZ576_Qm_tuaXQlA",
  authDomain: "erp-anya.firebaseapp.com",
  projectId: "erp-anya",
  storageBucket: "erp-anya.firebasestorage.app",
  messagingSenderId: "716171027960",
  appId: "1:716171027960:web:0a6cdd02308b5b9843a20d",
  measurementId: "G-JKEH047FZ1"
};

export const getFirebaseApp = (): FirebaseApp => {
  if (getApps().length) return getApp();
  return initializeApp(firebaseConfig);
};
